import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './stijl/thema.css';

const wortel = document.getElementById('root');
if (!wortel) throw new Error('Geen #root gevonden in index.html');

createRoot(wortel).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
